import React, { createRef } from 'react';
import { IonModal, IonInput, IonBackButton, IonButtons, IonButton, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import '../styles/Terms.scss';
import Server from '../Server';

class AllSets extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            sets: [],
            openedI: null
        }
    }

    async componentDidMount() {
        let data = await Server.getAllAdminSets();
        if (data && data.sets) {
            this.setState({
                sets: data.sets.map(set => {
                    console.log(set.tags)
                    set.tags = set.tags && set.tags.length !== 0 ? set.tags.join(",") : "";
                    console.log(set.notApproved)
                    set.notApproved = set.notApproved  ? "true" : "false"
                    return set;
                })
            })
        }
    }

    async save() {
        let set = JSON.parse(JSON.stringify(this.state.sets[this.state.openedI]))
        set.notApproved = set.notApproved === "false" ? false : true;
        set.tags = set.tags.split(",");
        await Server.updateAdminset(set);
        this.setState({
            openedI: null
        })
    }

    render() {
        let editedSet = this.state.openedI !== null ? this.state.sets[this.state.openedI] : null

        return (
            <IonPage data-page="terms">
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonBackButton text={window.ln.back} defaultHref="/" onClick={() => { this.props.history.goBack(); }} />
                        </IonButtons>
                        <IonTitle>Sets</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent>

                    <IonList>
                        { this.state.sets.map((set, i) => {
                            return (
                                <IonItem onClick={() => {
                                    this.setState({
                                        openedI: i
                                    })
                                }}>
                                    <IonLabel className="ion-text-wrap">
                                        <h2>{set.name}</h2>
                                        <h3>DL: {set.downloadedCountReal} Pending: {set.notApproved}</h3>
                                        <h4>[{set.term}] [{set.definition}] {set.tags}</h4>
                                    </IonLabel>
                                </IonItem>
                            )
                        }) }
                    </IonList>

                    <IonModal
                        isOpen={this.state.openedI !== null}
                        swipeToClose={true}
                        ref={this.entryModalRef}
                        onDidDismiss={() => {  }}
                        mode={"ios"}
                    >
                        { (this.state.openedI !== null && editedSet) &&
                            <div className="swipeable-drawer-body" data-drawer="export-import" className="export-import-modal">
                                <div className="options">
                                    <IonButton onClick={() => {
                                        this.setState({
                                            openedI: null
                                        })
                                    }}>CLOSE</IonButton>

                                    <IonButton onClick={() => {
                                        this.props.history.push("/set/" + editedSet.viewSecret)
                                    }}>CARDS</IonButton>
                                    <IonList>
                                        <IonItem>
                                            <IonLabel>Name</IonLabel>
                                            <IonInput value={editedSet.name} onIonChange={(e) => {
                                                editedSet.name = e.target.value;
                                            }}></IonInput>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Term</IonLabel>
                                            <IonInput value={editedSet.term} onIonChange={(e) => {
                                                editedSet.term = e.target.value;
                                            }}></IonInput>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Definition</IonLabel>
                                            <IonInput value={editedSet.definition} onIonChange={(e) => {
                                                editedSet.definition = e.target.value;
                                            }}></IonInput>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Not Approved</IonLabel>
                                            <IonInput value={editedSet.notApproved} onIonChange={(e) => {
                                                editedSet.notApproved = e.target.value;
                                            }}></IonInput>
                                        </IonItem>
                                        <IonItem>
                                            <IonLabel>Tags</IonLabel>
                                            <IonInput value={editedSet.tags} onIonChange={(e) => {
                                                editedSet.tags = e.target.value;
                                            }}></IonInput>
                                        </IonItem>
                                    </IonList>
                                </div>
                            </div>
                    }
                    <IonFabButton onClick={() => { this.save(); }} style={{ width: 'calc(100% - 20px)', '--border-radius': '56px' }}>
                        <IonLabel style={{ marginLeft: 8, fontWeight: 600, position: "relative", top: -1 }}>Save</IonLabel>
                    </IonFabButton>
                </IonModal>

                </IonContent>
            </IonPage>
        );
    }

};


export default withIonLifeCycle(AllSets);
